import { BaseBean } from "./BaseBean";
import { UnidadOrganicaBean } from "./UnidadOrganicaBean";


export class UsuarioBean extends BaseBean{
  public id:number;
  public apellidoPaterno:string;
  public apellidoMaterno:string;
  public nombres:string;
  public email:string;
  public numeroDocumento:string;
  public tipoDocumento:string;
  public perfil:string;
  public opciones:string;
  public numeroTelefono:string;
  public cargo:string;

  public unidadOrganica:UnidadOrganicaBean;
  public entidad: UnidadOrganicaBean;
  public despacho: UnidadOrganicaBean;
  public direccionGeneral: UnidadOrganicaBean;
  public direccionLinea: UnidadOrganicaBean;
  public area: UnidadOrganicaBean;
}
